<template>
  <v-dialog v-model="dialogVisible" fullscreen hide-overlay :retain-focus="false" persistent
    transition="dialog-bottom-transition">
    <template v-slot:activator="{ on, attrs }">
      <button class="btnDetails" v-bind="attrs" v-on="on" @click="dialogVisible = true"
        style="background-color: transparent;">
        <slot></slot>
      </button>
    </template>
    <v-card>
      <v-toolbar dark color="secondary">
        <v-btn icon dark class="btn btn-primary" @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>{{ $t('bonus.label.detailCommerce.title') }}</v-toolbar-title>

        <template v-slot:extension>
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider color="accent"></v-tabs-slider>

            <v-tab v-for="item in items" :key="item">
              {{ item }}
            </v-tab>
          </v-tabs>
        </template>

      </v-toolbar>

      <v-tabs-items v-model="tab" class="container mt-5">
        <v-tab-item>
          <div class="container mt-4">
            <detailBonusComponent :bonus="bonusProps"/>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>

import detailBonusComponent from '@/views/bonus/pages/detail_bonus/components/form_detail_bonus_component.vue';
import EventBus from '@/utils/event_bus.js';

export default {

  name: "detailBonusPage",
  components: {
    detailBonusComponent,
  },
  props: {
    bonusProps: {
      required: true
    },
  },

  data() {
    return {
      dialogVisible: false,
      tab: null,
      items: [
        this.$t('label.tab')
      ],
    }

  },

  async mounted() {

    EventBus.$on('reload-update-bonus', async () => {
      this.closeDialog()
    });
  },

  methods: {
    closeDialog() {
      this.dialogVisible = false;
      window.location.reload();
    },

  },
};
</script>

<style lang="css" scoped>
.btnDetails .v-icon {
  color: #6E17A5;
  margin-bottom: 12px;
}
</style>
